/* eslint-disable react-hooks/rules-of-hooks */
import {
  Box,
  Grid,
  Typography,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { CustomButton, CustomInput, Wrapper } from "../../components";
import { validationErrors } from "../../constants/validationErrors";
import { useTheme } from "@emotion/react";
import Select from "react-select";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppState } from "./state";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../utils";
import { userUpdate } from "../../slice/user.slice";
import { FormattedMessage, useIntl } from "react-intl";
import { LanguageContext } from "../../context/languageContext";
import {
  countryOptions,
  countryOptionsAr,
  countryOptionsFr,
} from "../../utils";

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    zIndex: "4",
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "52px",
    backgroundColor: "hsl(0deg 0% 97.65%)",
    borderRadius: "10px",
  }),
};

const OwnershipInformation = ({ onNext, onPrev }) => {
  const { locale, selectLanguage } = useContext(LanguageContext);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const { palette } = useTheme();
  const [countryLists, setCountryList] = useState(countryOptions);
  const userFormData = useSelector((state) => state.user.userFormData);
  let updateMessage = useIntl().formatMessage({ id: "yourRequestTaken" });

  const validationSchema = Yup.object().shape({
    ParentCompany: Yup.string().required("Parent Company Name is Required").max(255, useIntl().formatMessage({ id: "max255CharAllowed" })),
    UltimateOwner: Yup.string().required("Ultimate Owner is Required").max(255, useIntl().formatMessage({ id: "max255CharAllowed" })),
    Nationality: Yup.object().required("Nationality Name is Required"),
    NationalIDNumber: Yup.string().required("National ID Number is Required").max(255, useIntl().formatMessage({ id: "max255CharAllowed" })),
  });

  const [state, setState] = useAppState();
  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: state,
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  useEffect(() => {
    if (userFormData?.ParentCompany && !state.ParentCompany) {
      reset({
        ParentCompany: userFormData?.ParentCompany,
        UltimateOwner: userFormData?.UltimateOwner,
        Nationality: countryLists.filter(
          (item) => item.value === userFormData?.Nationality
        )[0],
        NationalIDNumber: userFormData?.NationalIDNumber,
      });
    }
    if (locale == "ar") {
      setCountryList(countryOptionsAr);
    } else if (locale == "fr") {
      setCountryList(countryOptionsFr);
    } else {
      setCountryList(countryOptions);
    }
  }, [userFormData]);

  const onSubmit = (data, name) => {
    setLoading(true);
    var finalData = data;
    setState({ ...state, ...finalData });
    onNext();
  };
  const onError = (errors, e) => {
    console.log(errors, e);
  };

  const handleSwitchLang = (lang) => {
    selectLanguage(lang);
    if (lang == "ar") {
      setCountryList(countryOptionsAr);
    } else if (lang == "fr") {
      setCountryList(countryOptionsFr);
    } else {
      setCountryList(countryOptions);
    }
  };

  return (
    <>
      {toast?.type && showToast(toast?.type, toast?.message, setToast)}
      <Box>
        {userFormData?.Status === "In Progress" && (
          <Wrapper>
            {" "}
            <FormHelperText
              sx={{
                fontSize: "20px",
                paddingBottom: "10px",
              }}
            >
              <strong>
                <FormattedMessage id="waitingAprroval" />
              </strong>
            </FormHelperText>
          </Wrapper>
        )}
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <Wrapper>
            <Box
              sx={
                userFormData?.Status === "In Progress"
                  ? {
                      opacity: [0.9, 0.8, 0.7],
                      pointerEvents: "none",
                    }
                  : {}
              }
            >
              <Grid
                container
                sx={{
                  "& .MuiGrid-container": {
                    marginBottom: "0 !important",
                    "& .MuiGrid-root": {
                      marginBottom: "20px",
                    },
                  },
                  "& .MuiGrid-root": {
                    marginBottom: "20px",
                  },
                }}
              >
                <Grid item lg={12} sm={12} xs={12}>
                  <CustomInput
                    label={useIntl().formatMessage({ id: "parentCompany" })}
                    type="text"
                    placeholder={useIntl().formatMessage({
                      id: "enterParentCompany",
                    })}
                    name="ParentCompany"
                    rules={{
                      required: validationErrors.required,
                    }}
                    error={errors?.ParentCompany?.message}
                    control={control}
                  />
                </Grid>
                <Grid item lg={12} sm={12} xs={12}>
                  <CustomInput
                    label={useIntl().formatMessage({ id: "ultimateOwner" })}
                    type="text"
                    placeholder={useIntl().formatMessage({
                      id: "enterUltimateOwner",
                    })}
                    name="UltimateOwner"
                    rules={{
                      required: validationErrors.required,
                    }}
                    error={errors?.UltimateOwner?.message}
                    control={control}
                  />
                </Grid>
                <Grid item lg={12} sm={12} xs={12}>
                  <Box component="div" className="form-group">
                    <InputLabel shrink htmlFor="bootstrap-input">
                      <FormattedMessage id="ultimateOwnerNationality" />
                    </InputLabel>
                    <Controller
                      name="Nationality"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          styles={customStyles}
                          options={countryLists}
                        />
                      )}
                    />
                    {errors?.Nationality?.message && (
                      <FormHelperText error>
                        {errors?.Nationality?.message}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid item lg={12} sm={12} xs={12}>
                  <CustomInput
                    label={useIntl().formatMessage({ id: "nationalID" })}
                    type="text"
                    placeholder={useIntl().formatMessage({
                      id: "enterNationalID",
                    })}
                    name="NationalIDNumber"
                    rules={{
                      required: validationErrors.required,
                    }}
                    error={errors?.NationalIDNumber?.message}
                    control={control}
                  />
                </Grid>
              </Grid>
            </Box>
          </Wrapper>
          <Box component="div">
            <Box className="dashboard-footer">
              <Box className="footer-item">
                <Typography
                  color={
                    locale === "en"
                      ? palette.secondary[700]
                      : palette.secondary[400]
                  }
                  onClick={() => handleSwitchLang("en")}
                >
                  <FormattedMessage id="english" />
                </Typography>
                <Typography
                  color={
                    locale === "fr"
                      ? palette.secondary[700]
                      : palette.secondary[400]
                  }
                  onClick={() => handleSwitchLang("fr")}
                >
                  <FormattedMessage id="french" />
                </Typography>
                <Typography
                  color={
                    locale === "ar"
                      ? palette.secondary[700]
                      : palette.secondary[400]
                  }
                  onClick={() => handleSwitchLang("ar")}
                >
                  <FormattedMessage id="arabic" />
                </Typography>
              </Box>
              <Box display="flex" columnGap="10px">
                <CustomButton
                  title={useIntl().formatMessage({ id: "back" })}
                  outline
                  size="small"
                  onClick={onPrev}
                />
                <CustomButton
                  title={useIntl().formatMessage({ id: "next" })}
                  size="small"
                  type="submit"
                  onClick={handleSubmit((data) => onSubmit(data, "next"))}
                />
                {/* {userFormData && userFormData?.Status !== "In Progress" && (
                  <CustomButton
                    title={useIntl().formatMessage({ id: "update" })}
                    type="submit"
                    size="small"
                    variant="contained"
                    loading={loading}
                    onClick={handleSubmit((data) => onSubmit(data, "update"))}
                  />
                )} */}
              </Box>
            </Box>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default OwnershipInformation;
